import React, { useState } from 'react';
import { ArrowLeftIcon, MapPinIcon, NavigationIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { venues } from '../data/venues';
export function VenuesMapScreen() {
  const navigate = useNavigate();
  const [selectedVenue, setSelectedVenue] = useState<string | null>(null);
  const selectedVenueData = selectedVenue ? venues.find(v => v.id === selectedVenue) : null;
  // Calculate center point of all venues
  const centerLat = venues.reduce((sum, v) => sum + v.latitude, 0) / venues.length;
  const centerLng = venues.reduce((sum, v) => sum + v.longitude, 0) / venues.length;
  // Calculate bbox to fit all venues
  const latitudes = venues.map(v => v.latitude);
  const longitudes = venues.map(v => v.longitude);
  const minLat = Math.min(...latitudes) - 0.05;
  const maxLat = Math.max(...latitudes) + 0.05;
  const minLng = Math.min(...longitudes) - 0.05;
  const maxLng = Math.max(...longitudes) + 0.05;
  const openGoogleMaps = (venue: (typeof venues)[0]) => {
    window.open(`https://www.google.com/maps/search/?api=1&query=${venue.latitude},${venue.longitude}`, '_blank');
  };
  return <div className="h-screen w-full flex flex-col bg-white" data-id="element-904">
      {/* Header */}
      <div className="bg-[#1f5070] px-4 py-4 flex items-center gap-3 shadow-md" data-id="element-905">
        <button onClick={() => navigate('/home')} className="p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-906">
          <ArrowLeftIcon className="w-6 h-6 text-white" data-id="element-907" />
        </button>
        <h1 className="text-xl font-bold text-[#c7f61e]" data-id="element-908">All Venues Map</h1>
      </div>

      {/* Map Container */}
      <div className="flex-1 relative" data-id="element-909">
        <iframe src={`https://www.openstreetmap.org/export/embed.html?bbox=${minLng},${minLat},${maxLng},${maxLat}&layer=mapnik`} className="w-full h-full border-0" title="All venues map" data-id="element-910" />

        {/* Venue Markers Overlay */}
        <div className="absolute inset-0 pointer-events-none" data-id="element-911">
          <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-912">
            {venues.map(venue => {
            // Convert lat/lng to SVG coordinates (rough approximation)
            const x = (venue.longitude - minLng) / (maxLng - minLng) * 100;
            const y = (maxLat - venue.latitude) / (maxLat - minLat) * 100;
            return <g key={venue.id} data-id="element-913">
                  <circle cx={x} cy={y} r="2" fill="#3dc7e3" stroke="white" strokeWidth="0.5" className="pointer-events-auto cursor-pointer animate-pulse" onClick={() => setSelectedVenue(venue.id)} data-id="element-914" />
                </g>;
          })}
          </svg>
        </div>
      </div>

      {/* Venue List Bottom Sheet */}
      <div className="bg-white border-t-2 border-gray-200 shadow-2xl max-h-[40vh] overflow-auto" data-id="element-915">
        <div className="px-4 py-3 border-b border-gray-200 bg-[#f8f9fa]" data-id="element-916">
          <h2 className="text-sm font-bold text-[#1f5070]" data-id="element-917">
            {venues.length} Venues in Brunei
          </h2>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-918">
          {venues.map(venue => <button key={venue.id} onClick={() => navigate(`/venue/${venue.id}`)} className="w-full p-4 flex items-center gap-4 hover:bg-[#f8f9fa] active:bg-gray-100 transition-colors text-left" data-id="element-919">
              <div className="w-12 h-12 bg-[#3dc7e3] rounded-full flex items-center justify-center flex-shrink-0" data-id="element-920">
                <MapPinIcon className="w-6 h-6 text-white" data-id="element-921" />
              </div>

              <div className="flex-1 min-w-0" data-id="element-922">
                <h3 className="text-base font-bold text-[#1f5070] mb-0.5" data-id="element-923">
                  {venue.name}
                </h3>
                <p className="text-sm text-[#666666] mb-1" data-id="element-924">{venue.location}</p>
                <p className="text-xs text-[#3dc7e3] font-medium" data-id="element-925">
                  {venue.totalCourts} courts • {venue.priceRangeUC.min}-
                  {venue.priceRangeUC.max} UC
                </p>
              </div>

              <button onClick={e => {
            e.stopPropagation();
            openGoogleMaps(venue);
          }} className="p-2 bg-[#3dc7e3] hover:bg-[#2db5d1] rounded-full transition-colors active:scale-95" data-id="element-926">
                <NavigationIcon className="w-5 h-5 text-white" data-id="element-927" />
              </button>
            </button>)}
        </div>
      </div>
    </div>;
}